import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { AuthService } from './api'
import AppRouter from './app/index'
import DemoApp from './demo_app'
import PopupHandler, { popup } from './popup_handler'
import DownloadContainer from './ui/download_container'
import { useApplyGiftCard } from './hooks/apply_giftcard'

//@ts-ignore
const handleNotification = (navigation: any, notification: string | null) => {
  if (!notification) return
  const { data } = JSON.parse(decodeURIComponent(atob(notification)))
  switch (data.type) {
    case 'TRANSACTION_OUT':
    case 'TRANSACTION_IN':
      return () =>
        popup.open('payment_receipt', {
          _id: data.order,
        })
  }
}
function App() {
  const user = useQuery(['user'], () => AuthService.Status())

  const [notification, setNotification] = useState<any>(null)
  useEffect(() => {
    if (!user || !user.data?._id || !notification) return
    // execute notification event
    notification()
  }, [user.data, notification])
  const navigation = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  useApplyGiftCard()
  useEffect(() => {
    try {
      /** register notification;
       * its kind of of queue but just stores one notification and waits for user to authenticate for execution */
      let query = new URLSearchParams(window.location.search)
      const notification = query.get('notification')
      if (notification) {
        /** notificaiton from url query */
        searchParams.delete('notification')
        setSearchParams(searchParams)
        setNotification(() => handleNotification(navigation, notification))
      }
      navigator.serviceWorker.addEventListener('message', (event) => {
        /** if cray is running in a browser tab */
        const { type, notification } = event.data
        if (type === 'NOTIFICATION_CLICK') {
          setNotification(() => handleNotification(navigation, notification))
        }
      })
    } catch (error) {
      console.log(error)
    }
  }, [])

  let location = useLocation()
  ;(window as any).location_key = location.key
  const IS_DEMO_APP = import.meta.env.VITE_DEMO_HOST === window.location.origin
  if (IS_DEMO_APP)
    return (
      <>
        <DemoApp />
        <PopupHandler />
      </>
    )
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div id="app" className="  relative overflow-hidden w-full md:w-[384px] mx-auto h-screen md:h-[667px] shadow">
        <AppRouter />
        <PopupHandler />
      </div>
      <DownloadContainer />
    </div>
  )
}

export default App
